function identityCandidates(value) {
    if (value === null || value === undefined || value === "") return [];
    if (typeof value !== "object") return [String(value)];
    return [value.documentId, value.id]
        .filter((item) => item !== null && item !== undefined && item !== "")
        .map(String);
}

function sameIdentity(left, right) {
    const rightIdentities = new Set(identityCandidates(right));
    return identityCandidates(left).some((identity) => rightIdentities.has(identity));
}

function hasIdentity(value) {
    return identityCandidates(value).length > 0;
}

export function buildMyTasksScopeFilter(workspace, membership) {
    const workspaceId = typeof workspace === "object"
        ? workspace?.id ?? workspace?.documentId
        : workspace;
    const membershipDocumentId = typeof membership === "object"
        ? membership?.documentId
        : membership;

    if (!workspaceId || !membershipDocumentId) return null;

    return {
        $and: [
            {workspace: {$eq: workspaceId}},
            {archivedAt: {$null: true}},
            {
                $or: [
                    {assignee: {documentId: {$eq: membershipDocumentId}}},
                    {
                        $and: [
                            {assignee: {$null: true}},
                            {creatorUser: {documentId: {$eq: membershipDocumentId}}},
                        ],
                    },
                ],
            },
        ],
    };
}

export function isTaskInMyTasksScope(task, workspace, membership) {
    if (!task || task.archivedAt !== null) return false;
    if (!sameIdentity(task.workspace, workspace)) return false;

    if (hasIdentity(task.assignee)) return sameIdentity(task.assignee, membership);
    return sameIdentity(task.creatorUser, membership);
}

export function filterMyTasksScope(tasks, workspace, membership) {
    return (Array.isArray(tasks) ? tasks : [])
        .filter((task) => isTaskInMyTasksScope(task, workspace, membership));
}

